<template>
    <div>
        <v-card-title class="soli-grey"
            >{{ results.length }} Results</v-card-title
        >
        <v-list dense>
            <v-list-item v-for="result in results" :key="result.id">{{
                result
            }}</v-list-item>
        </v-list>
    </div>
</template>

<script>
export default {
    props: {
        results: {
            type: Array,
            default: () => [],
        },
    },
};
</script>
